import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { productByAccountByActiveByNameDropDown } from "../../graphql/account/account-queries";

import { TextField, CircularProgress } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { useNotify } from "react-admin";
import { logError } from "../../utils/appUtils";

const getProducts = async (accountId, setProducts, notify, setFetching) => {
  try {
    const reloadYardId = window.appUser?.reloadYardId;
    if (!reloadYardId) {
      setProducts([]);
      setFetching(false);
      return;
    }

    if (accountId) {
      const input = {
        accountId,
        activeName: { beginsWith: { active: "true" } },
        limit: 1000,
      };
      const response = await API.graphql(
        graphqlOperation(productByAccountByActiveByNameDropDown, input),
      );
      setProducts(response.data.productByAccountByActiveByName.items);
    } else {
      setProducts([]);
    }

    setFetching(false);
  } catch (err) {
    logError("common:MuiProductDropDown:getProducts", err, notify);
    setFetching(false);
  }
};

export const MuiProductDropDown = ({
  label = "Product",
  disabled = false,
  required,
  error,
  helperText,
  value,
  onChange,
  accountId,
  ...props
}) => {
  const notify = useNotify();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getProducts(accountId, setProducts, notify, setLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  useEffect(() => {
    if (products.length > 0 && value?.id && !value?.name) {
      const defaultProduct = products.find((itm) => itm.id === value.id);
      if (defaultProduct) {
        onChange(defaultProduct);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, products]);

  const handleChange = (_, selected) => {
    onChange(selected || null);
  };

  return (
    <Autocomplete
      {...props}
      size="small"
      options={products}
      value={value || null}
      getOptionLabel={(option) => {
        if (typeof option === "string") return option;
        if (!option) return "";
        return option.productCode
          ? `${option.name} (${option.productCode})`
          : option.name;
      }}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      onChange={handleChange}
      loading={loading}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          label={label}
          required={required}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
